import { type FC, PropsWithChildren } from 'react';

import { QueryState } from '@/api/components/QueryState';
import { usePortfoliosQuery } from '@/api/portfolios';
import { isNotReady } from '@/api/utils/isNotReady';
import { useTexts } from '@/hooks/useTexts';

import { CenteredPageContent } from './CenteredPageContent';

export const WaitForPortfolioDetails: FC<PropsWithChildren> = ({
  children,
}) => {
  const texts = useTexts();
  const portfoliosQuery = usePortfoliosQuery();

  if (isNotReady(portfoliosQuery)) {
    return (
      <CenteredPageContent>
        <h1>{texts.pages.presentation.title}</h1>
        <QueryState
          query={portfoliosQuery}
          customTexts={{
            noData: {
              description:
                texts.pages.presentation.screens.portfolioPerformance
                  .noPortfolioGroup,
            },
          }}
        />
      </CenteredPageContent>
    );
  }

  return <>{children}</>;
};
